import { Role } from '@/constants/role.js'
const meta = { authorize: [Role.user] }

export default [
    {
        path: '/stat/translator-stat',
        name: 'translator-stat',
        meta,
        component: () => import('@pages2/p-translator-stat'),
    },
    {
        path: '/stat/translation-by-day-stat',
        name: 'translation-by-day-stat',
        meta,
        component: () => import('@pages2/p-translation-by-day-stat'),
    },
    {
        path: '/stat/project-stat',
        name: 'project-stat',
        meta,
        component: () => import('@pages2/p-project-stat'),
    },
    /*
    {
        path: '/stat',
        meta,
        children: [
            {
                path: '',
                name: 'translator-stat',
                meta,
                component: () => import('@pages2/p-translator-stat'),
            },
            {
                path: 'translation-by-day-stat',
                name: 'translation-by-day-stat',
                meta,
                component: () => import('@pages2/p-translation-by-day-stat'),
            },
        ],
    },
    */
]
